<template>
  <ul class="nav">
    <li class="nav-item" v-for="item in navItems" v-bind:key="item['.name']">
      <router-link :class="['nav-link']" :to="{ name: item.name }">{{ item.label }}</router-link>
    </li>
  </ul>
</template>

<script>
  import firebase from '@firebase/app'
  import '@firebase/auth'
  import database from '@/api/database.js'
  export default {
    name: 'navigation',
    data () {
      return {
        user: undefined,
        userProfile: undefined,
        photoURL: undefined
      }
    },
    mounted () {
      database.getCurrentUserAndProfile().then(userAndProfile => {
        this.user = userAndProfile.user
        this.userProfile = userAndProfile.profile
      })
    },
    computed: {
      navItems () {
        if (!this.user) {
          return []
        }
        if (['Admin','ViewAdmin'].indexOf(this.userProfile.role) > -1) {
          return [
            {
              name: 'home',
              label: 'Reports'
            },
            {
              name: 'timeline',
              label: 'Timeline'
            }
          ]
        } else { // not admin
          return [
          ]
        }
        return []
      }
    },
  }
</script>

<style scoped lang='scss'>
  .nav {
    margin: 3px 0 0;
    padding: 0;
    li {
      list-style: none;
      border-bottom: 1px solid rgb(189, 182, 183);
       a {
          color: #333;
          display: block;
          font-size: 1rem;
          text-decoration: none;
          padding: 15px 30px;
          &.router-link-active {
            font-weight: bold;
          }
       }
    }
    @media only screen and (min-width: 1024px) {  
      margin: 3px 0 0;  
      li {
        display: inline-block;
        font-weight: bold;
        height: 44px;
        padding: 0;
        margin-bottom: -4px;
        border-bottom: 0;
        a {
          padding: 10px 20px 10px;
          &.router-link-active {
            border-bottom: 3px solid #6e5f60;
            color: black;
          }
        }
      }
    }
  }
</style>
